import React, { useCallback, useEffect, useState } from 'react';
import { Card, Row, Col } from 'antd';
import HeadingTypography from '../../shared/Typography/Heading';
import TextTypography from '../../shared/Typography/Text';
import { getLeadsCount } from 'src/app/services/lead';
import { useCustomerContext } from 'src/app/contexts/customer';
import { getCustomerCount } from '@services';

const leadStats = {
    'Total Customers': 0,
    Approved: 0,
    Cash: 0,
    Active: 0,
    Blacklisted: 0,
};
interface LeadStatsType {
    'Total Customers': number;
    Approved: number;
    Cash: number;
    Active: number;
    Blacklisted: number;
}

const CustomerStatsCards: React.FC = () => {
    const { date } = useCustomerContext();

    const [data, setData] = useState<LeadStatsType>(leadStats);
    const fetchLeadsCount = useCallback(async () => {
        const resp = await getCustomerCount(date);
                
        setData({
            'Total Customers': resp?.totalCustomers ?? 0,
            Cash: resp?.cashCustomers ?? 0,
            'Approved': resp?.approvedCustomers ?? 0,
            Active: resp?.activeCustomers ?? 0,
            'Blacklisted': resp?.blacklistedCustomers ?? 0,
        });
    }, [date.startDate,date.endDate]);
    useEffect(() => {
        fetchLeadsCount();
    }, [fetchLeadsCount]);

    return (
        <div className="pt-6">
            <div className='flex w-full flex-wrap gap-4'>
                {Object.entries(data).map(([key, value], index) => (
                    <div key={index} className="flex-1 min-w-0">
                    <Card bordered={false} className="rounded-xl shadow-md bg-white h-full">
                      <div className="flex justify-between items-center">
                        <HeadingTypography fontSize={16}>{key}</HeadingTypography>
                        <TextTypography fontSize={16}>{value}</TextTypography>
                      </div>
                    </Card>
                  </div>
                ))}
            </div>
        </div>
    );
};

export default CustomerStatsCards;
